module.exports = __webpack_public_path__ + "img/sandbox.001a5275.jpg";